import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { initiateEasebuzzPayment } from '../../services/easebuzzServiceNew';

// Async thunk for initiating payment
export const initiateEasebuzzPaymentThunk = createAsyncThunk(
    'payment/initiateEasebuzz',
    async (paymentData, { rejectWithValue }) => {
        try {
            const response = await initiateEasebuzzPayment(paymentData);
            return response;
        } catch (error) {
            return rejectWithValue(error.message || 'Payment initiation failed');
        }
    }
);
export const initiateEasebuzzPaymentThunkRecharge = createAsyncThunk(
    'payment/initiateEasebuzzre',
    async (paymentData, { rejectWithValue }) => {
        try {
            const response = await initiateEasebuzzPayment(paymentData);
            return response;
        } catch (error) {
            return rejectWithValue(error.message || 'Payment initiation failed');
        }
    }
);

// Async thunk for verifying payment
export const verifyEasebuzzPayment = createAsyncThunk(
    'payment/verifyEasebuzz',
    async (verificationData, { rejectWithValue }) => {
        try {
            // This would typically be called from your backend after webhook verification
            // For now, we'll simulate the response structure
            return {
                status: verificationData.status || 'success',
                transaction_id: verificationData.txn_id,
                amount: verificationData.amount,
                email: verificationData.email
            };
        } catch (error) {
            return rejectWithValue(error.message || 'Payment verification failed');
        }
    }
);

const paymentSlice = createSlice({
    name: 'payment',
    initialState: {
        loading: false,
        error: null,
        paymentInitiated: false,
        paymentStatus: 'idle', // 'idle', 'initiated', 'success', 'failed'
        transactionId: null,
        paymentData: null,

        loadingrecharge: false,
        errorrecharge: null,
        paymentInitiatedrecharge: false,
        paymentStatusrecharge: 'idle', // 'idle', 'initiated', 'success', 'failed'
        transactionIdrecharge: null,
        paymentDatarecharge: null,
    },
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        resetPayment: (state) => {
            state.loading = false;
            state.error = null;
            state.paymentInitiated = false;
            state.paymentStatus = 'idle';
            state.transactionId = null;
            state.paymentData = null;
        },
        setPaymentStatus: (state, action) => {
            state.paymentStatus = action.payload.status;
            state.transactionId = action.payload.transaction_id;
        },
        handleEasebuzzResponse: (state, action) => {
            const response = action.payload;
            // console.log('Easebuzz response received:', response);

            if (response.txnid) {
                state.transactionId = response.txnid;
                state.paymentStatus = response.status === 'success' ? 'success' : 'failed';
            }
        }
    },
    extraReducers: (builder) => {
        builder
            // Initiate Easebuzz Payment
            .addCase(initiateEasebuzzPaymentThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.paymentInitiated = false;
            })
            .addCase(initiateEasebuzzPaymentThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.paymentInitiated = true;
                state.paymentStatus = 'initiated';
                state.paymentData = action.payload;
            })
            .addCase(initiateEasebuzzPaymentThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.paymentInitiated = false;
                state.paymentStatus = 'failed';
            }).addCase(initiateEasebuzzPaymentThunkRecharge.pending, (state) => {
                state.loadingrecharge = true;
                state.errorrecharge = null;
                state.paymentInitiatedrecharge = false;
            })
            .addCase(initiateEasebuzzPaymentThunkRecharge.fulfilled, (state, action) => {
                state.loadingrecharge = false;
                state.paymentInitiatedrecharge = true;
                state.paymentStatusrecharge = 'initiated';
                state.paymentDatarecharge = action.payload;
            })
            .addCase(initiateEasebuzzPaymentThunkRecharge.rejected, (state, action) => {
                state.loadingrecharge = false;
                state.errorrecharge = action.payload;
                state.paymentInitiatedrecharge = false;
                state.paymentStatusrecharge = 'failed';
            })
            // Verify Payment
            .addCase(verifyEasebuzzPayment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(verifyEasebuzzPayment.fulfilled, (state, action) => {
                state.loading = false;
                state.paymentStatus = action.payload.status;
                state.transactionId = action.payload.transaction_id;
            })
            .addCase(verifyEasebuzzPayment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.paymentStatus = 'failed';
            });
    },
});

export const {
    clearError,
    resetPayment,
    setPaymentStatus,
    handleEasebuzzResponse
} = paymentSlice.actions;

export default paymentSlice.reducer;